// How far the walker has got with a Plan's Gear List: how many items they've
// answered, and how many Essential items they've marked not taking (which
// warns, but never blocks starting; ADR-0017).
export const gearSummary = (gearList) => ({
  answered: gearList.filter((item) => item.status !== 'UNANSWERED').length,
  essentialsNotTaking: gearList.filter(isEssentialNotTaking).length,
});

export const isEssentialNotTaking = (item) =>
  item.essential && item.status === 'NOT_TAKING';
